import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  alpha,
} from '@mui/material';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import { PasswordRequirements as PasswordRequirementsType } from '../utils/passwordValidation';

interface PasswordRequirementsProps {
  requirements: PasswordRequirementsType;
  showTitle?: boolean;
}

const requirementsList = [
  { key: 'minLength', label: 'Be at least 8 characters long' },
  { key: 'hasLowercase', label: 'Contain at least one lowercase letter' },
  { key: 'hasUppercase', label: 'Contain at least one uppercase letter' },
  { key: 'hasNumber', label: 'Contain at least one number' },
  { key: 'hasSpecialChar', label: 'Contain at least one special character' },
];

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  requirements,
  showTitle = true,
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      {showTitle && (
        <Typography variant="body2" sx={{ fontWeight: 'medium', mb: 1 }}>
          Password must:
        </Typography>
      )}
      <List dense sx={{ py: 0 }}>
        {requirementsList.map(({ key, label }) => {
          const isMet = requirements[key as keyof PasswordRequirementsType];
          return (
            <ListItem key={key} disablePadding sx={{ py: 0.25 }}>
              <ListItemIcon sx={{ minWidth: 32 }}>
                {isMet ? (
                  <CheckCircle
                    sx={{
                      color: 'success.main',
                      fontSize: 16,
                    }}
                  />
                ) : (
                  <RadioButtonUnchecked
                    sx={{
                      color: 'text.secondary',
                      fontSize: 16,
                    }}
                  />
                )}
              </ListItemIcon>
              <ListItemText
                primary={label}
                sx={{
                  '& .MuiListItemText-primary': {
                    fontSize: '0.875rem',
                    color: isMet ? 'success.main' : 'text.secondary',
                    fontWeight: isMet ? 'medium' : 'normal',
                  },
                }}
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default PasswordRequirements;